<script lang="ts" setup generic="Value extends string | number">
import PopOver from '#components/popover/PopOver.vue';
import { ListboxOption } from '@headlessui/vue';
import type { Component } from 'vue';

export type InputSelectOptionType<Value extends string | number> = {
  value: Value;
  label: string;
  disabled?: boolean;
  isPlaceholder?: boolean;
  hint?: string;
  icon?: Component;
};

defineProps({
  options: { type: Array<InputSelectOptionType<Value>>, required: true }
});
</script>

<template>
  <ListboxOption
    v-for="option in options"
    :key="option.value"
    v-slot="{ active, selected }"
    as="template"
    class="flex items-center"
    :value="option"
    :disabled="option.disabled"
  >
    <li
      :class="{
        'cursor-pointer': !option.disabled,
        'cursor-default text-default-neutral-217': option.disabled,
        'bg-background-celeste': active
      }"
      class="relative select-none flex items-center h-14 text-gray-900 space-x-2"
    >
      <div
        :class="{
          'font-semibold': selected && !option.isPlaceholder,
          'font-normal': !selected,
          'text-default-neutral-217': option.isPlaceholder || option.disabled
        }"
        class="block truncate ml-6 flex items-center gap-2"
      >
        <component
          :is="option.icon"
          v-if="option.icon"
          class="w-5 h-5 flex-shrink-0 text-neutral-blueGray fill-neutral-blueGray"
        />
        <span>{{ option.label }}</span>
      </div>
      <!-- Duplicated in "ButtonBase.vue" -->
      <PopOver v-if="option.hint" position="right">
        <VueFeather
          class="cursor-pointer mt-1 text-black !text-opacity-100 !pointer-events-auto"
          v-bind="{ type: 'info', size: '16' }"
          aria-hidden="true"
        />

        <template #content>
          <span>{{ option.hint }}</span></template
        >
      </PopOver>
    </li>
  </ListboxOption>
</template>
